var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.total)?_c('el-pagination',{attrs:{"border":"","current-page":_vm.page,"page-sizes":_vm.sizes,"page-size":_vm.size,"layout":_vm.layout,"total":_vm.total},on:{"size-change":_vm.onSizeChange,"current-change":_vm.onCurrentPage}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }